import React from 'react';
import { Icon } from 'src/components/atoms/Icon';

type TrendIndicatorProps = {
  trend: 'up' | 'down';
};

export const TrendIndicator: React.FC<TrendIndicatorProps> = ({ trend }) => {
  return (
    <>
      {trend === 'up' ? (
        <Icon
          iconName="arrow-diagonal-up"
          height="20px"
          width="20px"
          ml=".5rem"
          color="icon.green"
        />
      ) : (
        <Icon
          iconName="arrow-diagonal-down"
          height="20px"
          width="20px"
          ml=".5rem"
          color="icon.red"
        />
      )}
    </>
  );
};
